<template>
  <div class="my-favorites-view">
    <div class="page-header">
      <h2>我的收藏</h2>
    </div>

    <div class="photos-grid" v-if="photos.length">
      <div v-for="photo in photos" :key="photo.imageId" class="photo-item">
        <div class="photo-actions">
          <button class="unfavorite-btn" @click.prevent="unfavoritePhoto(photo.imageId)">
            <i class="fas fa-heart-broken"></i>
            取消收藏
          </button>
        </div>
        <router-link :to="`/photos/${photo.imageId}`" class="photo-link" target="_blank">
          <div class="photo-preview">
            <img :src="photo.imageUrl" :alt="photo.imageName">
            <div class="photo-info">
              <h3>{{ photo.imageName }}</h3>
              <div class="photo-tags">
                <span v-for="tag in photo.tags ? photo.tags.split(',') : []" :key="tag" class="tag">
                  {{ tag }}
                </span>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <div class="empty-state" v-else>
      <i class="fas fa-heart"></i>
      <p>还没有收藏任何图片</p>
      <router-link to="/photos" class="browse-btn">
        去浏览图片
      </router-link>
    </div>

    <div class="pagination" v-if="total > pageSize">
      <button
        class="page-btn"
        :disabled="pageNum === 1"
        @click="changePage(pageNum - 1)"
      >
        <i class="fas fa-chevron-left"></i>
      </button>
      <span class="page-info">{{ pageNum }} / {{ totalPages }}</span>
      <button
        class="page-btn"
        :disabled="pageNum === totalPages"
        @click="changePage(pageNum + 1)"
      >
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { request } from '@/utils/request'

export default {
  name: 'MyFavoritesView',
  data() {
    return {
      photos: [],
      pageNum: 1,
      pageSize: 12,
      total: 0,
      loading: false
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize)
    }
  },
  created() {
    this.fetchPhotos()
  },
  methods: {
    async fetchPhotos() {
      if (this.loading) return
      this.loading = true

      try {
        const response = await request(`/api/image/favorite/list?pageNum=${this.pageNum}&pageSize=${this.pageSize}`)

        if (response.ok) {
          this.photos = response.data.list
          this.total = response.data.total
        } else {
          throw new Error(response.msg || '获取收藏列表失败')
        }
      } catch (error) {
        console.error('获取收藏列表失败:', error)
        alert('获取收藏列表失败，请重试')
      } finally {
        this.loading = false
      }
    },
    async unfavoritePhoto(imageId) {
      try {
        const response = await request(`/api/image/favorite/${imageId}`, {
          method: 'POST'
        })

        if (response.ok) {
          // 刷新列表
          this.fetchPhotos()
        } else {
          throw new Error(response.msg || '取消收藏失败')
        }
      } catch (error) {
        console.error('取消收藏失败:', error)
        alert('取消收藏失败，请重试')
      }
    },
    changePage(page) {
      this.pageNum = page
      this.fetchPhotos()
      // 滚动到顶部
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.my-favorites-view {
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
}

.page-header {
  margin-bottom: 30px;
}

.photos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 24px;
  margin-bottom: 30px;
}

.photo-item {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  position: relative;
}

.photo-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.photo-actions {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.photo-item:hover .photo-actions {
  opacity: 1;
}

.unfavorite-btn {
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #f44336;
  font-size: 14px;
  transition: all 0.3s ease;
}

.unfavorite-btn:hover {
  background: #f44336;
  color: white;
}

/* 复用 MyPhotosView 的其他样式 */
.photo-link {
  text-decoration: none;
  color: inherit;
  display: block;
  height: 100%;
}

.photo-preview {
  position: relative;
  padding-top: 75%;
}

.photo-preview img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photo-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: linear-gradient(transparent, rgba(0,0,0,0.7));
  color: white;
}

.photo-info h3 {
  margin: 0;
  font-size: 16px;
  margin-bottom: 8px;
}

.photo-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.tag {
  padding: 2px 8px;
  background: rgba(255,255,255,0.2);
  border-radius: 12px;
  font-size: 12px;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.empty-state i {
  font-size: 48px;
  color: #ddd;
  margin-bottom: 16px;
}

.browse-btn {
  display: inline-block;
  padding: 8px 16px;
  background: #4CAF50;
  color: white;
  border-radius: 4px;
  text-decoration: none;
  margin-top: 16px;
  transition: all 0.3s ease;
}

.browse-btn:hover {
  background: #43A047;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 30px;
}

.page-btn {
  width: 36px;
  height: 36px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-btn:not(:disabled):hover {
  border-color: #4CAF50;
  color: #4CAF50;
}

.page-info {
  font-size: 14px;
  color: #666;
}

@media (max-width: 768px) {
  .my-favorites-view {
    margin: 20px auto;
  }

  .photos-grid {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 16px;
  }

  .photo-info h3 {
    font-size: 14px;
  }

  .unfavorite-btn {
    padding: 6px 10px;
    font-size: 12px;
  }
}
</style>
